import React from "react";

const sizes = {
  xs: "text-[5px] font-normal",
  lg: "text-base font-normal",
  s: "text-sm font-normal",
  "2xl": "text-3xl font-medium md:text-[28px] sm:text-[26px]",
  xl: "text-[17px] font-medium",
  md: "text-[15px] font-normal",
};

export type TextProps = Partial<{
  className: string;
  as: any;
  size: keyof typeof sizes;
}> &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const Text: React.FC<React.PropsWithChildren<TextProps>> = ({
  children,
  className = "",
  as,
  size = "md",
  ...restProps
}) => {
  const Component = as || "p";

  return (
    <Component className={`text-blue_gray-400 font-poppins ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
